import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { utc } from 'moment';

@Injectable({ providedIn: 'root' })
export class CustomNativeDateAdapter extends NativeDateAdapter {
  private readonly dateFormat = 'YYYY-MM-DD';

  override parse(value: any): Date | null {
    if (typeof value === 'string') {
      const momentDate = utc(value, this.dateFormat, true);
      return momentDate.isValid() ? momentDate.toDate() : null;
    }
    return value ? new Date(value) : null;
  }

  override format(date: Date): string {
    return utc(date).format(this.dateFormat);
  }

  override createDate(year: number, month: number, date: number): Date {
    return utc({ year, month, date }).toDate();
  }
}
